import React from 'react';
import { StringHelpers } from '@salesperformanceint/e4shared';

import './rating.css';

export const Rating = ({ hideLabel, smallStar, limit, value, onChange }) => {
    const [rating, setRating] = React.useState(value);

    const setRatingWrapper = i => {
        if (onChange) {
            setRating(i);
            onChange(i);
        }
    };

    const star = i => (
        <span className="pull-left">
            <span style={{ position: 'relative' }}>
                <i
                    className={`fa fa-star ${smallStar ? 'fa-sm' : ''} ${rating >= i ? 'on' : ''}`}
                    onClick={() => setRatingWrapper(i)}
                />
                {rating > i && rating < i + 1 && (
                    <i
                        className={`fa fa-star ${smallStar ? 'fa-sm' : ''} ${rating >= i ? 'on' : ''}`}
                        style={{ position: 'absolute', top: '2px' }}
                        onClick={() => setRatingWrapper(i)}
                    />
                )}
            </span>
            {i > 1 && star(i - 1)}
        </span>
    );

    return (
        <div className="rating-stars">
            <div className={`${onChange ? 'edit' : 'view'} rating`}>
                {!hideLabel && <label>Rating</label>}
                <span
                    className="pull-left"
                    title={onChange || !value ? '' : `Scored ${value} ${StringHelpers.pluralise('star', value)}`}
                >
                    {star(limit || 5)}
                </span>
                <span />
            </div>
        </div>
    );
};

export default Rating;
